export default __webpack_public_path__ + "static/media/06.7bafbbe8.jpg";